// Single reactive read of the gamification feature flags (#229). Mirrors
// features/desktop/useDesktopShellEnabled.ts — the boot fetch sets the cache
// AFTER first paint, so any component that gates UI on the flag must re-render
// when it flips. Every consumer reads through here so the reactivity lives in
// ONE place.
import { useSyncExternalStore } from "react";
import {
  readGamificationFlags,
  readGamificationFlagsAuthoritative,
  subscribeGamificationFlags,
  type GamificationFlags,
} from "./gamification-flag";

export function useGamificationFlags(): GamificationFlags {
  return useSyncExternalStore(
    subscribeGamificationFlags,
    readGamificationFlags,
    readGamificationFlags,
  );
}

/** Current-document authority, kept separate from the persisted paint hint. */
export function useGamificationFlagsAuthoritative(): boolean {
  return useSyncExternalStore(
    subscribeGamificationFlags,
    readGamificationFlagsAuthoritative,
    readGamificationFlagsAuthoritative,
  );
}

/** Convenience read of the master `gamification.enabled` switch. When false the
 *  entire widget renders nothing (rollout starts all-off). */
export function useGamificationEnabled(): boolean {
  return useGamificationFlags().enabled;
}
